<template>
  <!-- <el-input
    v-bind="$attrs"
    :value="value"
    :clearable="clearable"
    @input="$emit('input', $event)"
    @clear="searchHandler"
    @keyup.enter.native="enterHandler"
    :style="{ width: width }"
  >
    <template slot="append">
      <div @click="searchHandler">
        <i class="icon icon-search"></i>
      </div>
    </template>
  </el-input> -->

  <el-button
    :size="size"
    :type="type"
    @click="$emit('click',$event)"
    :style="{'padding':'0', width:width,height:height,'text-align': 'center', 'min-width': '32px'}"
  >
    <i class="el-icon-plus"></i>
  </el-button>

</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'small'
    },
    type: {
      type: String,
      default: 'primary'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '28px'
    },
    height: {
      type: String,
      default: '28px'
    }
  },
};
</script>
